module.exports = __webpack_public_path__ + "media/images/empty-filter-e4a96ec22a402fe6d124af30e90e07e5.png";